import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IRole, AppConstants } from '../models';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { IRolesResponse, IRoleResponse, IRolesByUserResponse, IResponse, BaseResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private httpClient: HttpClient) { }

  Post(_role: IRole): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Role/StoreRole`;
    
    return this.httpClient.post<BaseResponse>(url, _role, { headers });
  }

  Get(): Observable<IResponse<IRole[]>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Role/GetRoles`;
    
    return this.httpClient.get<IResponse<IRole[]>>(url, { headers });
  }

  GetRole(_idRole: number): Observable<IResponse<IRole>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Role/GetRoleById?id=${_idRole}`;
    
    return this.httpClient.get<IResponse<IRole>>(url, { headers });
  }

  Put(_role: IRole): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Role/StoreRole`;
    
    return this.httpClient.post<BaseResponse>(url, _role, { headers });
  }

  GetByUser(_idUser: number): Observable<IResponse<IRole[]>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Role/GetRolesByUser?id=${_idUser}`;
    
    return this.httpClient.get<IResponse<IRole[]>>(url, { headers });
  }
}
